import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';

import { LinkifyPipe } from '../shared/linkify.pipe';
import { AppStartupService } from './app-startup.service';
import { JWTService } from './jwt.service';
import { SocketService } from './socket.service';
import { TypingIndicatorAnimationComponent } from './typing-indicator-animation/typing-indicator-animation.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    ToastrModule.forRoot({
      timeOut: 5000,
    }),
  ],
  declarations: [TypingIndicatorAnimationComponent, LinkifyPipe],
  providers: [SocketService, JWTService, AppStartupService],
  exports: [TranslateModule, TypingIndicatorAnimationComponent, LinkifyPipe, ToastrModule],
})
export class SharedModule {}
